import { Stack, Typography } from "@mui/material";
import BadgedAvatar from "../../../features/base/BadgedAvatar";
import { RoutineItemInfo } from "../../../redux/routine/routineItemSlice";
import { assertImagesUrl } from "../../../redux/common";

interface RoutineItemCellProps {
    item: RoutineItemInfo;
}

const RoutineItemCell = ({
    item
}: RoutineItemCellProps) => {
    return (
        <Stack key={item.id} direction="row" alignItems="center" spacing={1}>
            <Stack key={"item-" + item.id} direction="row" sx={{ mx: "2px", my: 1, width: "180px" }}>
                <BadgedAvatar
                    avatar={assertImagesUrl(item.url)}
                    title={item.name}
                    size="24px"
                    fontSize="small"
                />
                <Typography
                    variant="body2"
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }}
                >
                    {item.name}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default RoutineItemCell;
